import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableHeader,
} from '@occc-app/design-system';

import { ScanDataPastSubmissionTableRow } from './scan-data-past-submission-table-row';

import { ReSubmitExistingFileDialog } from '../../scan-data-weekly-file/components/re-submit-existing-file-dialog';
import { SubmissionGroupData } from '../../scan-data-weekly-file/scan-data-weekly-file.types';
import { useScanDataWeeklyFileResubmit } from '../../scan-data-weekly-file/hooks/use-scan-data-weekly-file-resubmit.hook';
import { pastSubmissionsTypeToLabelMap } from '../../scan-data-weekly-file/scan-data-weekly-file.constants';

type ScanDataPastSubmissionTableProps = {
  data: SubmissionGroupData[];
  submissionDate: string;
};

export const ScanDataPastSubmissionTable = ({
  data,
  submissionDate,
}: ScanDataPastSubmissionTableProps) => {
  const {
    isResubmitDialogOpen,
    openResubmitDialog,
    closeResubmitDialog,
    handleResubmitConfirm,
    isSubmitting,
  } = useScanDataWeeklyFileResubmit();

  const currentSubmission = data?.find((item) => isResubmitDialogOpen);
  const handleResubmitClick = () => openResubmitDialog(submissionDate);

  return (
    <>
      <TableContainer sx={{ mb: 1 }}>
        <TableHeader title='Submissions' />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>SFTP Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Submission Group</TableCell>
              <TableCell>File Status</TableCell>
              <TableCell>Resubmitted</TableCell>
              <TableCell align='right'></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item: SubmissionGroupData) => (
              <ScanDataPastSubmissionTableRow
                key={item.visibleId}
                data={item}
                onResubmitClick={handleResubmitClick}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {currentSubmission && (
        <ReSubmitExistingFileDialog
          open={isResubmitDialogOpen}
          onClose={closeResubmitDialog}
          onConfirm={handleResubmitConfirm}
          franchiseName={pastSubmissionsTypeToLabelMap[currentSubmission.type]}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  );
};
